import { useMutation } from '@tanstack/react-query';
import { uploadOfferImage } from '../services/api';

interface UseImageUploadOptions {
  onSuccess?: (result: { filename: string; url: string }) => void;
  onError?: (error: Error) => void;
}

/**
 * Hook for uploading images to S3 with presigned URLs
 */
export const useImageUpload = (options?: UseImageUploadOptions) => {
  return useMutation({
    mutationFn: async (params: { file: File; offerId?: number | string; name?: string }) => {
      const { file, offerId, name } = params;
      const resp = await uploadOfferImage(file, offerId, name);
      return resp.data; // { filename, url }
    },
    onSuccess: (data) => {
      options?.onSuccess?.(data);
    },
    onError: (error) => {
      console.error('Failed to upload image:', error);
      options?.onError?.(error as Error);
    },
  });
};
